import {
  PhotoCheckDetailDialog,
  resultLabel
} from '@/components/responses/photos/photo-checks-gallery.component';
import { useRunPhotosStore } from '@/stores/run/run-photos.store';
import { useState } from 'react';
import PhotoGeofenceBadge from './photo-geofence-badge.component';
import { formatPhotoTime } from './run-photo-check-camera.component';

/**
 * When the creator opens a run from Analytics: this task's latest photo next to its title,
 * with what was seen and when. Click to see it large.
 */
export default function RunTaskPhotoThumb({ taskId }: { taskId?: string }) {
  const item = useRunPhotosStore(s => (taskId ? s.byTask[taskId] : undefined));
  const [open, setOpen] = useState(false);
  if (!item) return <></>;

  const result = item.tasks.find(t => t.task_id === taskId);
  const label = result ? resultLabel(result) : undefined;
  const time = new Date(item.taken_at || item.checked_at);

  return (
    <>
      <button
        type="button"
        className="shrink-0 flex items-center gap-2 rounded border border-black/10 bg-white p-0.5 pr-2 hover:shadow"
        title="See the photo"
        onClick={e => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        {item.photo ? (
          <img
            src={item.photo}
            alt="Task photo"
            className="h-9 w-12 rounded object-cover bg-black/5"
          />
        ) : (
          <span className="h-9 w-12 rounded bg-black/5 flex items-center justify-center text-[10px] text-black/40">
            No photo
          </span>
        )}
        <span className="flex flex-col items-start leading-tight">
          {label && (
            <span className={'rounded px-1 text-[10px] ' + label.className}>
              {label.text}
            </span>
          )}
          <span className="text-[10px] text-black/50">
            {formatPhotoTime(time)}
          </span>
          <PhotoGeofenceBadge
            geofence={item.geofence}
            location={item.location}
            compact
          />
        </span>
      </button>
      {open && (
        <PhotoCheckDetailDialog item={item} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
